export default __webpack_public_path__ + "static/media/fatimaNcake_w1024.5a2be0ae.jpeg";